module.exports = __webpack_public_path__ + "img/06.34c87474.jpg";